import { Flame, Pencil, GripVertical, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MemberAvatar } from "@/components/MemberAvatar";
import { recurrenceLabel } from "@/lib/recurrence";
import { cn } from "@/lib/utils";

export function ChoreCard({ chore, assignees, done, filter, dp, snapshot, onComplete, onEdit }) {
  return (
    <div
      ref={dp.innerRef}
      {...dp.draggableProps}
      data-testid={`chore-card-${chore.id}`}
      className={cn("bento-tile flex items-center gap-3 p-4", snapshot.isDragging && "ring-2 ring-primary")}
    >
      {!filter && (
        <span {...dp.dragHandleProps} className="cursor-grab text-muted-foreground/60">
          <GripVertical className="h-5 w-5" />
        </span>
      )}
      <button
        onClick={() => onComplete(chore)}
        data-testid={`chore-complete-${chore.id}`}
        className={cn(
          "flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 transition-all bento-pressable",
          done ? "border-mint bg-mint text-white" : "border-border hover:border-primary"
        )}
      >
        {done && <Check className="h-5 w-5" strokeWidth={3} />}
      </button>
      <div className="min-w-0 flex-1">
        <p className={cn("truncate font-display font-semibold text-ink", done && "line-through opacity-50")}>
          {chore.title}
        </p>
        <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-muted-foreground">
          <span>{recurrenceLabel(chore)}</span>
          <span>· {chore.points} pts</span>
          {chore.streak > 0 && (
            <span className="inline-flex items-center gap-0.5 font-semibold text-clay">
              <Flame className="h-3.5 w-3.5" /> {chore.streak}
            </span>
          )}
        </div>
      </div>
      <div className="flex -space-x-2">
        {assignees.slice(0, 3).map((m) => (
          <MemberAvatar key={m.id} member={m} size="sm" />
        ))}
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 rounded-full"
        onClick={() => onEdit(chore)}
        data-testid={`chore-edit-${chore.id}`}
      >
        <Pencil className="h-4 w-4" />
      </Button>
    </div>
  );
}
